import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function AddProduct() 
{  const [userData, setuserData] = useState({})
  console.log(userData);
  const navigate = useNavigate();
  
  const onChange = (e)=>{
    setuserData({...userData, [e.target.name]: e.target.value})
  }

  const onSubmit =async (e)=>{
    e.preventDefault()
    console.log(userData);

    try {


        const getToken = localStorage.getItem("authToken");
      const response = await fetch("http://localhost:3022/users/createProduct", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Server ko batata hai data JSON format me hai
          Authorization: `Bearer ${getToken}`,
        },
        body: JSON.stringify(userData), // Body me data send karte hain
      });

      const data = await response.json(); // Response ko JSON me convert kare

      if (response.ok) {
        // Login successful
        // setSuccess("Login successful!");
        // alert("Registered Successfully");
         toast?.success(data.message)
        navigate('/product-list');
        console.log("User data:", data);
      } else {
        console.log("error:");
        // Login failed
        // setError(data.message || "Login failed");
      } 
    } catch (err) {
      // setError("Something went wrong. Please try again.");
    }


  }
  return (
    <div className="App" style={{display:'flex',flexDirection:'column',gap:'10px',backgroundColor:'lightblue',width:'100%',height:'100vh',alignItems:'center',justifyContent:'center'}}>
    
  <input type="text" name='name'   onChange={onChange}    placeholder='name'  />
  <input type="text" name='price'   onChange={onChange}    placeholder='price' />
  <input type="text" name='description' onChange={onChange} placeholder='description' />
  <input type="text" name='size'   onChange={onChange}    placeholder='size' />
  <input type="text" name='color'   onChange={onChange}    placeholder='color' />
 

  <button onClick={(e)=>onSubmit(e)}>Submit</button>
 </div>
   )
}

export default AddProduct